/*
 * Stub for react-native-image-crop-picker for webpack
 * so web builds don't fail
 */
export default {
  openCamera: (): void => {
    // Stub function for web
  },
  openPicker: (): void => {
    // Stub function for web
  },
};
const Image = {};
const Options = {};

export { Image, Options };
